import { useEffect, useState } from 'react'
import { getAddonsAuthBasic } from '../services'
import { IResponseGetAddOns } from '../../interfaces/src'

export const useGetAddonsAuthBasic = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [addons, setAddons] = useState<IResponseGetAddOns | null>(null)
  const [isError, setIsError] = useState(false)

  const fetchAddons = async () => {
    setIsLoading(true)
    try {
      const response = await getAddonsAuthBasic()
      if (response.isSuccess && response.data) {
        setAddons(response?.data)
        setIsError(false)
      } else {
        setIsError(true)
      }
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!addons && !isError && !isLoading) {
      fetchAddons()
    }
  }, [addons])

  return {
    fetchAddons,
    isLoading,
    addons,
    isError
  }
}
